import { PropTypes } from 'prop-types';

import { Box } from '@mui/material';

import StyledLink from '../StyledLink';

const StyledLinkComponent = ({ amenities }) => (
  <Box display="flex" gap="1rem" flexWrap="wrap">
    {amenities?.map(({ name, id }, i) => {
      const isNotLast = i + 1 < amenities?.length;
      const doorUrl = `/amenity/management/info/${id}`;
      return (
        <StyledLink
          key={id}
          to={doorUrl}
          sx={{ fontWeight: 'bold', color: 'inherit' }}
        >
          {name}
          {isNotLast && ','}
        </StyledLink>
      );
    })}
  </Box>
);

StyledLinkComponent.propTypes = {
  amenities: PropTypes.instanceOf(Array),
};

export default StyledLinkComponent;
